<template>
    <div class="setting-style-width d-flex flex-column justify-content-center">
        <div class="w-100 pb-2 d-flex align-items-center">
            <label for="styleTextAlign" class="font-14 m-0">
                Alinhamento
            </label>

            <div class="ml-3 d-flex justify-content-center align-items-center">
                <button id="deslock" v-if="isLockStyleTextAlign" @click="handlerUnlockStyleTextAlign">
                    <i class="fal fa-lock font-14"></i>
                </button>

                <button id="lock" v-else @click="handlerLockStyleTextAlign">
                    <i class="fal fa-lock-open font-14"></i>
                </button>
            </div>
        </div>

        <div class="row no-gutters">
            <button
                v-for="(align, key) in aligns"
                :key="key"
                class="button-align col-4"
                :class="align.value ==  alignActive? 'active' : ''"
                @click="setAlign(align.value)"
                :disabled="isLockStyleTextAlign"
            >
                <div class="d-flex justify-content-center align-items-center">
                    <div v-html="align.icon"></div>
                </div>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SettingFrameStyleTextAlign',
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            alignActive: 'left',
            aligns: [
                { id: 1, name: "Alinhar a esquerda", value: 'left', icon: `<svg xmlns="http://www.w3.org/2000/svg" width="22.25" height="26.081"
                    viewBox="0 0 22.25 26.081">
                    <g id="Grupo_3622" data-name="Grupo 3622" transform="translate(-381 -260.5)">
                        <rect id="Retângulo_2308" data-name="Retângulo 2308" width="6.932" height="17.878" rx="1"
                            transform="translate(403.25 275.182) rotate(90)" fill="var(--main-color)" />
                        <rect id="Retângulo_2309" data-name="Retângulo 2309" width="6.932" height="12.041" rx="1"
                            transform="translate(397.412 264.966) rotate(90)" fill="var(--main-color)" />
                        <line id="Linha_25" data-name="Linha 25" x2="24.081"
                            transform="translate(382 261.5) rotate(90)" fill="none" stroke="var(--main-color)"
                            stroke-linecap="round" stroke-width="2" />
                    </g>
                </svg>` },
                { id: 2, name: "Alinhar ao centro", value: 'center', icon: `<svg xmlns="http://www.w3.org/2000/svg" width="17.878" height="26.081"
                    viewBox="0 0 17.878 26.081">
                    <g id="Grupo_3624" data-name="Grupo 3624" transform="translate(-429 -260.5)">
                        <g id="Grupo_3348" data-name="Grupo 3348" transform="translate(28 -707.475)">
                            <rect id="Retângulo_2308" data-name="Retângulo 2308" width="6.932" height="17.878"
                                rx="1" transform="translate(418.878 982.657) rotate(90)" fill="var(--main-color)" />
                            <rect id="Retângulo_2309" data-name="Retângulo 2309" width="6.932" height="12.041"
                                rx="1" transform="translate(416.041 972.441) rotate(90)" fill="var(--main-color)" />
                            <line id="Linha_25" data-name="Linha 25" x2="24.081"
                                transform="translate(409.5 968.975) rotate(90)" fill="none" stroke="var(--main-color)"
                                stroke-linecap="round" stroke-width="2" />
                        </g>
                    </g>
                </svg>`},
                { id: 3, name: "Alinhar a direita", value: 'right', icon: `<svg xmlns="http://www.w3.org/2000/svg" width="22.25" height="26.081"
                    viewBox="0 0 22.25 26.081">
                    <g id="Grupo_3623" data-name="Grupo 3623" transform="translate(-472 -260.5)">
                        <g id="Grupo_3347" data-name="Grupo 3347" transform="translate(28 -707.475)">
                            <rect id="Retângulo_2308" data-name="Retângulo 2308" width="6.932" height="17.878"
                                rx="1" transform="translate(461.878 982.657) rotate(90)" fill="var(--main-color)" />
                            <rect id="Retângulo_2309" data-name="Retângulo 2309" width="6.932" height="12.041"
                                rx="1" transform="translate(461.878 972.441) rotate(90)" fill="var(--main-color)" />
                            <line id="Linha_25" data-name="Linha 25" x2="24.081"
                                transform="translate(465.25 968.975) rotate(90)" fill="none" stroke="var(--main-color)"
                                stroke-linecap="round" stroke-width="2" />
                        </g>
                    </g>
                </svg>`},
            ],
        }
    },
    methods: {
        onChangeStyleTextAlign() {
            this.$emit('onChangeStyleTextAlign', this.alignActive);
        },
        handlerLockStyleTextAlign() {
            this.$emit('onChangeStyleTextAlignLock', true);
        },
        handlerUnlockStyleTextAlign() {
            this.$emit('onChangeStyleTextAlignLock', false);
        },
        setAlign(align) {
            this.alignActive = align;
        }
    },
    computed: {
        isLockStyleTextAlign() {
            return this.item.extra.style_text_align_lock;
        },
    },
    watch: {
        alignActive() {
            this.onChangeStyleTextAlign();
        },
    },
    created() {
        if (this.item.extra.style && this.item.extra.style.textAlign) {
            this.alignActive = this.item.extra.style.textAlign;
        }
    },
}
</script>

<style scoped>
.button-align {
    background: transparent;
    border: 2px solid transparent;
    border-radius: 5px;
    outline: none;
    padding: 0.5rem;
    margin: 0;
    width: 100%;
    height: 100%;
}

.button-align.active {
    border: 2px solid var(--main-color);
}

#deslock,
#lock {
    background: transparent;
    border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/atoms/SettingFrameStyleTextAlign.vue